import React from "react";
import { Link } from "react-router-dom";

// A minimal, cinematic intro. The screen starts almost black; the starfield
// gently wakes; then two quiet sentences, the logo, and two calm choices fade in.
const fadeIn = (delay) => ({ animation: "continua-fade 1.6s ease forwards", animationDelay: delay });

export default function Landing() {
  return (
    <div
      className="relative min-h-screen overflow-hidden text-violet-50 flex items-center justify-center px-6 pt-safe-top pb-safe-bottom"
      data-testid="intro-screen"
    >
      {/* The night sky slowly waking up */}

      <div className="relative z-10 w-full max-w-2xl text-center">
        <h1
          className="font-serif-display text-3xl md:text-5xl leading-tight opacity-0"
          style={fadeIn("1.1s")}
          data-testid="intro-headline"
        >
          The story doesn't end{" "}
          <span className="italic text-violet-200/90">when you fall asleep.</span>
        </h1>

        <p
          className="mt-5 text-base md:text-lg text-violet-200/70 opacity-0"
          style={fadeIn("1.1s")}
          data-testid="intro-subline"
        >
          A companion who remembers you.
        </p>

        <div
          className="mt-16 opacity-0"
          style={fadeIn("2.1s")}
        >
          <div className="flex flex-col items-center gap-4">
            <img
              src="/continua-logo.png"
              alt="Continua"
              className="w-28 h-auto object-contain"
              data-testid="landing-logo-symbol"
            />
            <span className="font-serif-display text-2xl tracking-wide text-violet-50">Continua</span>
          </div>
        </div>

        <div
          className="mt-10 flex flex-col sm:flex-row gap-4 justify-center opacity-0"
          style={fadeIn("3s")}
        >
          <Link
            to="/meet"
            data-testid="intro-meet-button"
            className="silicone-button glass-strong inline-flex items-center justify-center rounded-full px-8 py-4 text-violet-50 font-medium border border-violet-200/30 hover:border-violet-100/50 transition-soft glow-violet"
          >
            Meet your companion
          </Link>
          <Link
            to="/login"
            data-testid="intro-returning-button"
            className="silicone-button glass inline-flex items-center justify-center rounded-full px-8 py-4 text-violet-200 border border-violet-300/20 hover:text-violet-50 hover:border-violet-300/40 transition-soft glow-silver"
          >
            I've been here before
          </Link>
        </div>
      </div>
    </div>
  );
}
